<div class="dashboard-container">
  <!-- Header Section -->
  <div class="dashboard-header">
    <div class="header-content">
      <h1 class="dashboard-title">
        <i class="fas fa-chart-line"></i>
        داشبورد مدیریت رستوران
      </h1>
      <p class="dashboard-subtitle">نمای کلی عملکرد رستوران شما</p>
    </div>
    <div class="header-actions">
      <button (click)="loadDashboardData()"
              [disabled]="isLoading"
              class="refresh-btn">
        <i [class.fa-spin]="isLoading"
           class="fas fa-sync-alt"></i>
        بروزرسانی
      </button>
    </div>
  </div>
  <!-- Loading Spinner -->
  @if (isLoading) {
    <div class="loading-overlay">
      <div class="spinner">
        <i class="fas fa-spinner fa-spin"></i>
        <p>در حال بارگذاری...</p>
      </div>
    </div>
  }

  <!-- Main Dashboard Content -->
  @if (!isLoading) {
    @if (branches.length !== 1) {
      <div class="branch-section mb-4">
        <div class="section-title">
          <mat-icon>store</mat-icon>
          <span>{{ 'SelectBranch' | translate }}</span>
        </div>
        <div class="branch-container">
          <div class="branch-grid">
            @if (branches && branches.length > 0) {
              @for (branch of branches; track branch.BusinessId) {
                <div (click)="onBranchClick(branch)"
                     [ngClass]="{'selected': isBranchSelected(branch)}"
                     class="branch-item">
                  <div class="branch-icon">
                    <mat-icon>store</mat-icon>
                  </div>
                  <div class="branch-info">
                    <h4 class="branch-title">{{ branch.Title }}</h4>
                    @if (branch.Address) {
                      <p class="branch-address">{{ branch.Address }}</p>
                    }
                  </div>
                  <div class="branch-selection-indicator">
                    <img [src]="isBranchSelected(branch) ? '/icons/tick-circle.svg' : '/icons/circle.svg'"
                         alt="selection">
                  </div>
                </div>
              }
            } @else {
              <div class="no-branches">
                <mat-icon>store</mat-icon>
                <p>{{ 'LoadingBranches' | translate }}</p>
              </div>
            }
          </div>
        </div>
      </div>
    }
    <div class="dashboard-content">
      <!-- Statistics Cards Row 1 -->
      <div class="stats-row">
        <div class="stat-card primary">
          <div class="stat-icon">
            <i class="fas fa-shopping-cart"></i>
          </div>
          <div class="stat-content">
            <h3 class="stat-title">کل سفارشات</h3>
            <form [formGroup]="dashboardStats">
              <p class="stat-value">{{ total.get('count')?.value | number:'1.0-0' }}</p>
              <div class="stat-changes">
                <p class="stat-change positive">
                  <i class="fas fa-arrow-up"></i>
                  امروز: {{ daily.get('count')?.value | number:'1.0-0' }}
                </p>
                <p class="stat-change info">
                  <i class="fas fa-calendar-week"></i>
                  هفته جاری: {{ weekly.get('count')?.value | number:'1.0-0' }}
                </p>
                <p class="stat-change warning">
                  <i class="fas fa-calendar-alt"></i>
                  ماه جاری: {{ monthly.get('count')?.value | number:'1.0-0' }}
                </p>
              </div>
            </form>
          </div>
        </div>
        <div class="stat-card success">
          <div class="stat-icon">
            <i class="fas fa-money-bill-wave"></i>
          </div>
          <div class="stat-content">
            <h3 class="stat-title">درآمد کل</h3>
            <form [formGroup]="dashboardStats">
              <p class="stat-value">{{ formatCurrency(total.get('income')?.value) }}</p>
              <p class="stat-change positive">
                <i class="fas fa-arrow-up"></i>
                امروز: {{ formatCurrency(daily.get('income')?.value) }}
              </p>
            </form>
          </div>
        </div>
        <div class="stat-card warning">
          <div class="stat-icon">
            <i class="fas fa-calendar-alt"></i>
          </div>
          <div class="stat-content">
            <h3 class="stat-title">سفارشات ماه جاری</h3>
            <form [formGroup]="dashboardStats">
              <p class="stat-value">{{ monthly.get('count')?.value | number:'1.0-0' }}</p>
              <p class="stat-change positive">
                <i class="fas fa-arrow-up"></i>
                درآمد ماه جاری: {{ formatCurrency(monthly.get('income')?.value) }}
              </p>
            </form>
          </div>
        </div>
        <div class="stat-card info">
          <div class="stat-icon">
            <i class="fas fa-users"></i>
          </div>
          <div class="stat-content">
            <h3 class="stat-title">کل کاربران</h3>
            <form [formGroup]="dashboardStats">
              <p class="stat-value">{{ dashboardStats.get('totalUsers')?.value | number:'1.0-0' }}</p>
            </form>
            <p class="stat-change">
              <i class="fas fa-clock"></i>
              ساعت شلوغی: {{ dashboardStats.get('peakHours')?.value }}
            </p>
          </div>
        </div>
      </div>
      <!-- Quick Actions -->
      <div class="quick-actions mb-2">
        <h3 class="section-title">عملیات سریع</h3>
        <div class="action-buttons">
          <button (click)="createNewOrder()"
                  class="action-btn primary">
            <i class="fas fa-plus"></i>
            سفارش جدید
          </button>
          <button (click)="manageClients()"
                  [disabled]="isNavigatingToClients"
                  class="action-btn success">
            <i class="fas fa-users"></i>
            مدیریت مشتریان
          </button>
          <button (click)="openSettings()"
                  class="action-btn warning">
            <i class="fas fa-cog"></i>
            تنظیمات
          </button>
          <button (click)="openReports()"
                  class="action-btn info">
            <i class="fas fa-file-alt"></i>
            گزارش
          </button>
        </div>
      </div>
      <!-- Charts Section -->
      <div class="charts-section">
        <div class="chart-container">
          <div class="chart-header">
            <h3>نمودار درآمد ۷ روز گذشته</h3>
          </div>
          <div class="chart-content">
            @if (isLoadingCharts) {
              <div class="chart-placeholder">
                <i class="fas fa-chart-line"></i>
                <p>در حال بارگذاری نمودار...</p>
              </div>
            }
            @if (!isLoadingCharts) {
              <form [formGroup]="dashboardStats">
                <div class="chart-bars"
                     formArrayName="daysBeforeNowReport">
                  @for (ctrl of daysBeforeNowReportFA.controls; track i; let i = $index) {
                    <div [formGroupName]="i"
                         class="bar-col">
                      <span class="bar-count">{{ formatCurrency(ctrl.get('income')?.value) }}</span>
                      <div [style.height]="(((ctrl.get('income')?.value || 0) / getMaxIncomes()) * 200) + 'px'"
                           class="chart-bar">
                        <span class="bar-income">{{ ctrl.get('count')?.value }}</span>
                        <div class="bar-tooltip">
                          <strong>{{ ctrl.get('date')?.value | time:'YYYY-MM-DD' }}</strong>
                          <br>
                          تعدا سفارشات: {{ ctrl.get('count')?.value }}
                          <br>
                          {{ formatCurrency(ctrl.get('income')?.value) }}
                        </div>
                      </div>
                      <span class="bar-date">{{ ctrl.get('date')?.value | time:'YYYY-MM-DD' }}</span>
                    </div>
                  }
                </div>
              </form>
            }
          </div>
        </div>
        <div class="chart-container">
          <div class="chart-header">
            <h3>درآمد دوره‌ای</h3>
          </div>
          <div class="chart-content">
            @if (isLoadingCharts) {
              <div class="chart-placeholder">
                <i class="fas fa-chart-line"></i>
                <p>در حال بارگذاری نمودار...</p>
              </div>
            }
            @if (!isLoadingCharts) {
              <div class="revenue-period-chart">
                @for (item of revenueByPeriodChartData; track i; let i = $index) {
                  <div class="period-item">
                    <div class="period-label">{{ item.period }}</div>
                    <div [style.height]="(item.revenue / getMaxRevenueByPeriod() * 200) + 'px'"
                         class="period-bar">
                      <div class="bar-tooltip">
                        <strong>{{ item.period }}</strong>
                        <br>
                        {{ formatCurrency(item.revenue) }}
                      </div>
                    </div>
                    <div class="period-value">{{ formatCurrency(item.revenue) }}</div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
      <!-- Additional Charts Section -->
      <div class="charts-section">
        <div class="chart-container">
          <div class="chart-header">
            <h3>محبوب‌ترین غذاها</h3>
          </div>
          <div class="chart-content">
            @if (isLoadingCharts) {
              <div class="chart-placeholder">
                <i class="fas fa-chart-pie"></i>
                <p>در حال بارگذاری نمودار...</p>
              </div>
            }
            @if (!isLoadingCharts) {
              <form [formGroup]="dashboardStats">
                <div class="popular-items-chart"
                     formArrayName="popularItems">
                  @for (ctrl of popularItems.controls; track i; let i = $index) {
                    <div [formGroupName]="i"
                         class="popular-item">
                      <div class="item-info">
                        <div class="item-name">{{ ctrl.get('serviceTitle')?.value }}</div>
                        <div class="item-category">{{ ctrl.get('categoryTitle')?.value }}</div>
                      </div>
                      <div class="item-stats">
                        <div class="item-orders">{{ ctrl.get('count')?.value }} سفارش</div>
                        <div class="item-revenue">{{ formatCurrency(ctrl.get('income')?.value) }}</div>
                      </div>
                      <div [style.width]="((ctrl.get('count')?.value || 0) / getMaxPopularItems() * 100) + '%'"
                           class="item-bar"></div>
                    </div>
                  }
                </div>
              </form>
            }
          </div>
        </div>
        <div class="chart-container">
          <div class="chart-header">
            <h3>سفارشات ساعتی</h3>
            <div class="chart-controls">
              <button (click)="onPeriodChange('DAILY')"
                      [class.active]="selectedPeriod === 'DAILY'"
                      class="period-btn">
                امروز
              </button>
              <button (click)="onPeriodChange('WEEKLY')"
                      [class.active]="selectedPeriod === 'WEEKLY'"
                      class="period-btn">
                هفته
              </button>
              <button (click)="onPeriodChange('MONTHLY')"
                      [class.active]="selectedPeriod === 'MONTHLY'"
                      class="period-btn">
                ماه
              </button>
              <button (click)="onPeriodChange('TOTAL')"
                      [class.active]="selectedPeriod === 'TOTAL'"
                      class="period-btn">
                کلی
              </button>
            </div>
          </div>
          <div class="chart-content">
            <form [formGroup]="dashboardStats">
              <div class="hourly-chart"
                   formArrayName="hourlyReport">
                @for (ctrl of hourlyReport.controls; track i; let i = $index) {
                  <div [formGroupName]="i"
                       [style.height]="((ctrl.get('count')?.value || 0) / getMaxOrders() * 150) + 'px'"
                       class="hourly-bar">
                    <div class="hour-label">{{ ctrl.get('hour')?.value }}</div>
                    <div class="hour-value">{{ ctrl.get('count')?.value }}</div>
                  </div>
                }
              </div>
            </form>
          </div>
        </div>
      </div>
      <!-- Order Status Cards -->
      <div class="status-section">
        <h3 class="section-title">وضعیت فاکتورها</h3>
        <div class="status-cards">
          <div class="status-card pending">
            <div class="status-icon">
              <i class="fas fa-file-alt"></i>
            </div>
            <div class="status-content">
              <h4>ثبت سفارش</h4>
              <p class="status-count">{{ dashboardStats.get('factorStatusCounts.submit')?.value }}</p>
            </div>
          </div>
          <div class="status-card confirmed">
            <div class="status-icon">
              <i class="fas fa-credit-card"></i>
            </div>
            <div class="status-content">
              <h4>در انتظار پرداخت</h4>
              <p class="status-count">{{ dashboardStats.get('factorStatusCounts.pendingPayment')?.value }}</p>
            </div>
          </div>
          <div class="status-card preparing">
            <div class="status-icon">
              <i class="fas fa-check-circle"></i>
            </div>
            <div class="status-content">
              <h4>تایید اولیه</h4>
              <p class="status-count">{{ dashboardStats.get('factorStatusCounts.progressing')?.value }}</p>
            </div>
          </div>
          <div class="status-card ready">
            <div class="status-icon">
              <i class="fas fa-utensils"></i>
            </div>
            <div class="status-content">
              <h4>درحال آماده سازی</h4>
              <p class="status-count">{{ dashboardStats.get('factorStatusCounts.preparation')?.value }}</p>
            </div>
          </div>
          <div class="status-card processing">
            <div class="status-icon">
              <i class="fas fa-truck"></i>
            </div>
            <div class="status-content">
              <h4>درانتظار پیک</h4>
              <p class="status-count">{{ dashboardStats.get('factorStatusCounts.processingCenter')?.value }}</p>
            </div>
          </div>
          <div class="status-card delivery">
            <div class="status-icon">
              <i class="fas fa-shipping-fast"></i>
            </div>
            <div class="status-content">
              <h4>ارسال شده</h4>
              <p class="status-count">{{ dashboardStats.get('factorStatusCounts.deliveryDispatcher')?.value }}</p>
            </div>
          </div>
          <div class="status-card delivered">
            <div class="status-icon">
              <i class="fas fa-check-double"></i>
            </div>
            <div class="status-content">
              <h4>تحویل شده</h4>
              <p class="status-count">{{ dashboardStats.get('factorStatusCounts.delivered')?.value }}</p>
            </div>
          </div>
          <div class="status-card cancelled">
            <div class="status-icon">
              <i class="fas fa-times-circle"></i>
            </div>
            <div class="status-content">
              <h4>لغو شده توسط کاربر</h4>
              <p class="status-count">{{ dashboardStats.get('factorStatusCounts.canceled')?.value }}</p>
            </div>
          </div>
          <div class="status-card cancelled">
            <div class="status-icon">
              <i class="fas fa-times-circle"></i>
            </div>
            <div class="status-content">
              <h4>لغو شده توسط سیستم</h4>
              <p class="status-count">{{ dashboardStats.get('factorStatusCounts.canceledBySystem')?.value }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- Recent Orders Section -->
      <div class="recent-orders-section">
        <div class="section-header">
          <h3 class="section-title">آخرین سفارشات</h3>
          <button (click)="viewAllFactors()"
                  [disabled]="isNavigating"
                  class="view-all-btn"
                  title="مشاهده همه فاکتورها با جزئیات کامل">
            <i [class.fa-external-link-alt]="!isNavigating"
               [class.fa-spin]="isNavigating"
               [class.fa-spinner]="isNavigating"
               class="fas"></i>
            {{ isNavigating ? 'در حال انتقال...' : 'مشاهده همه' }}
          </button>
        </div>
        <div class="orders-table">
          <div class="table-header">
            <div class="header-cell">شماره سفارش</div>
            <div class="header-cell">مشتری</div>
            <div class="header-cell">مبلغ</div>
            <div class="header-cell">وضعیت</div>
            <div class="header-cell">تاریخ</div>
          </div>
          <form [formGroup]="dashboardStats">
            <div class="table-body"
                 formArrayName="recentOrders">
              @for (ctrl of recentOrders.controls; track i; let i = $index) {
                <div [formGroupName]="i"
                     class="table-row">
                  <div class="table-cell order-id">#{{ ctrl.get('factorId')?.value || i + 1 }}</div>
                  <div class="table-cell customer">
                    <div (click)="viewUserDetail(ctrl.get('userId')?.value)"
                         [class.clickable]="ctrl.get('userId')?.value"
                         [style.cursor]="ctrl.get('userId')?.value ? 'pointer' : 'default'"
                         [title]="ctrl.get('userId')?.value ? 'کلیک کنید تا جزئیات کاربر را مشاهده کنید' : ''"
                         class="customer-info">
                      <i class="fas fa-user"></i>
                      <span>{{ ctrl.get('customer')?.value || 'مشتری' }}</span>
                    </div>
                  </div>
                  <div class="table-cell amount">
                    {{ formatCurrency(ctrl.get('amount')?.value) }}
                  </div>
                  <div class="table-cell status">
                                    <span [style.background-color]="ctrl.get('statusColor')?.value"
                                          class="status-badge">
                                      {{ ctrl.get('status')?.value | translate }}
                                    </span>
                  </div>
                  <div class="table-cell date">
                    {{ ctrl.get('date')?.value | time:'YYYY-MM-DD' }}
                  </div>
                </div>
              }
              @if (recentOrders.controls.length === 0) {
                <div class="no-orders">
                  <i class="fas fa-inbox"></i>
                  <p>هیچ سفارشی یافت نشد</p>
                </div>
              }
            </div>
          </form>
        </div>
      </div>
    </div>
  }
</div>
